import { toast } from "sonner";
import { CheckCircle, Info, AlertTriangle, XCircle } from "lucide-react";

type ToastOptions = { persistent?: boolean; description?: string; width?: string; duration?: number; showCloseButton?: boolean };

const buildToastOptions = (type: "success" | "error", options?: ToastOptions) => ({
  position: "bottom-center" as const,
  description: options?.description,
  duration: options?.duration !== undefined ? options.duration : (options?.persistent ? Infinity : 4000),
  ...(options?.width && {
    style: {
      width: options.width,
      maxWidth: options.width,
      left: "50%",
      transform: "translateX(-50%)",
    },
  }),
  ...(options?.showCloseButton && {
    closeButton: true,
    // Toaster is unstyled, so sonner's default close button position/colors must be overridden
    classNames: {
      [type]: "pr-10",
      closeButton:
        "!absolute !left-auto !right-2 !top-2 !transform-none !h-6 !w-6 !bg-white/20 !border-0 !text-white hover:!bg-white/40 rounded-full flex items-center justify-center [&>svg]:h-4 [&>svg]:w-4",
    },
  }),
});

export const showSuccessToast = (message?: string, options?: ToastOptions) => {
  toast.success(message || "Operation completed successfully", {
    icon: <CheckCircle className="h-5 w-5 " />,
    ...buildToastOptions("success", options),
  });
};

export const showInfoToast = (message?: string) => {
  toast.info(message || "Here's some useful information", {
    icon: <Info className="h-5 w-5 " />,
    position: "bottom-center",
  });
};

export const showWarningToast = (message?: string) => {
  return toast.warning(message || "Proceed with caution", {
    icon: <AlertTriangle className="h-5 w-5 " />,
    position: "bottom-center",
  });
};

export const showErrorToast = (message?: string, options?: ToastOptions) => {
  return toast.error(message || "An error occurred", {
    // XCircle looks like a second close button next to the real one
    icon: options?.persistent ? null : <XCircle className="h-5 w-5" />,
    ...buildToastOptions("error", options),
  });
};
